import type { Extensions } from '@tiptap/core';
import Link from '@tiptap/extension-link';
import Image from '@tiptap/extension-image';
import {
	Table,
	TableCell,
	TableHeader,
	TableRow,
} from '@tiptap/extension-table';
import { Markdown } from 'tiptap-markdown';

/** Table, Link, Image, and Markdown extensions shared by Jepto TipTap editors. */
export function jeptoRichMarkdownExtensions(): Extensions {
	return [
		Table.configure({
			resizable: true,
			handleWidth: 4,
			cellMinWidth: 50,
		}),
		TableRow,
		TableHeader,
		TableCell,
		Link.configure({
			openOnClick: false,
			autolink: true,
			defaultProtocol: 'https',
		}),
		Image.configure({
			allowBase64: true,
			HTMLAttributes: {
				class: 'editor-image',
			},
		}),
		Markdown.configure({
			html: false,
			bulletListMarker: '-',
			tightLists: true,
			breaks: true,
		}),
	];
}
